import React from 'react';

const NotFound = () => (
  <p>Not Found</p>
);

export default NotFound;
